import React from 'react'
import { MkAccountContext } from '@account/contexts/core'

export const useAccount = () => {
  const context = React.useContext(MkAccountContext)

  if (!context) {
    throw new Error('useAccount must be used within a MkAccountProvider')
  }

  return context
}
